/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Validation_Pix_Key_TypeInputs */

const en_clients_validation_pix_key_type = /** @type {(inputs: Clients_Validation_Pix_Key_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PIX key does not match the selected type.`)
};

const pt_br2_clients_validation_pix_key_type = /** @type {(inputs: Clients_Validation_Pix_Key_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A chave PIX não corresponde ao tipo selecionado.`)
};

/**
* | output |
* | --- |
* | "PIX key does not match the selected type." |
*
* @param {Clients_Validation_Pix_Key_TypeInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_validation_pix_key_type = /** @type {((inputs?: Clients_Validation_Pix_Key_TypeInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Validation_Pix_Key_TypeInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_validation_pix_key_type(inputs)
	return pt_br2_clients_validation_pix_key_type(inputs)
});